module.exports = {
    title: "随心惠_惠合科技营销互动平台_让营销服务数字智能化",
    description: "惠合科技“随心惠”是面向消费者的营销互动平台，提供“领券、找店、核销”多项能力，为品牌在非连锁门店的C端营销活动提供落地支撑。",
    keywords: "领取优惠券,到店核销,查找附近门店,扫码活动,惠合科技,随心惠"
}